import { Head } from "@inertiajs/react"
import { Alert, Box, Button, Container, Stack, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"

type Props = {
  flash?: { alert?: string | null }
}

function readCsrfToken(): string {
  if (typeof document === "undefined") return ""
  const meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null
  return meta?.content ?? ""
}

export default function SignIn({ flash }: Props) {
  const [csrfToken, setCsrfToken] = useState("")

  useEffect(() => {
    setCsrfToken(readCsrfToken())
  }, [])

  return (
    <>
      <Head title="Sign in" />
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Stack
          spacing={3}
          component="form"
          method="post"
          action="/users/sign_in"
          noValidate
          data-testid="sign-in-form"
        >
          <Typography variant="h4" component="h1">Sign in</Typography>
          {flash?.alert && <Alert severity="error">{flash.alert}</Alert>}
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <TextField
            label="Email"
            name="user[email]"
            type="email"
            required
            fullWidth
            slotProps={{ htmlInput: { "data-testid": "email-input" } }}
          />
          <TextField
            label="Password"
            name="user[password]"
            type="password"
            required
            fullWidth
            slotProps={{ htmlInput: { "data-testid": "password-input" } }}
          />
          <Box>
            <Button type="submit" variant="contained" data-testid="sign-in-submit">
              Sign in
            </Button>
          </Box>
        </Stack>
      </Container>
    </>
  )
}
